module.exports = __webpack_public_path__ + "img/banner-2.6f1e238b.png";